import React from "react";

// HRFlo logo — hexagon + checkmark mark, "HR" navy, "Flo" sky, with tagline.
export function LogoMark({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M50 6 L86 26 L86 66 Q86 74 78 78 L54 92 Q50 94 46 92 L14 74 Q6 70 6 62 L6 26 Z"
        stroke="#7EA8E3"
        strokeWidth="7"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M30 50 L44 64 L72 30"
        stroke="#7EA8E3"
        strokeWidth="9"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export default function Logo({ size = "md", showTagline = true, className = "" }) {
  const markSize = size === "sm" ? 30 : size === "lg" ? 52 : 40;
  const textSize = size === "sm" ? "text-xl" : size === "lg" ? "text-4xl" : "text-2xl";
  const tagSize = size === "lg" ? "text-[11px]" : "text-[9px]";
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={markSize} />
      <div className="flex flex-col leading-none">
        <div className={`font-display font-extrabold tracking-tight ${textSize}`}>
          <span className="text-brand-navy">HR</span>
          <span className="text-brand-sky">Flo</span>
        </div>
        {showTagline && (
          <div className={`${tagSize} font-semibold tracking-[0.18em] text-brand-navy/70 mt-1`}>
            PEOPLE · RECORDS · COMPLIANCE
          </div>
        )}
      </div>
    </div>
  );
}
